(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expandable-container"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('expandable-container')) {
    customElements.define('expandable-container', class ExpandableContainer extends HTMLElement {
      connectedCallback() {
        this.staticPart = this.querySelector('[data-expandable-static]');
        this.toggleButton = this.querySelector('[data-expandable-toggle]');
        this.panel = this.querySelector('[data-expandable-panel]');
        this.panelInner = this.querySelector('[data-expandable-panel-inner]');
        if (!this.staticPart || !this.panel) return;

        this.panel.id = this.panel.id || `ExpandablePanel-${Math.random().toString(36).slice(2)}`;
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-controls', this.panel.id);
        }
        this.staticPart.setAttribute('aria-controls', this.panel.id);

        this.handleToggleClick = this.handleToggleClick || this.onToggleClick.bind(this);
        this.handleStaticClick = this.handleStaticClick || this.onStaticClick.bind(this);
        this.handleStaticKeydown = this.handleStaticKeydown || this.onStaticKeydown.bind(this);
        this.handleResize = this.handleResize || this.updatePanelHeight.bind(this);

        if (this.toggleButton) {
          this.toggleButton.removeEventListener('click', this.handleToggleClick);
          this.toggleButton.addEventListener('click', this.handleToggleClick);
        }

        this.staticPart.removeEventListener('click', this.handleStaticClick);
        this.staticPart.removeEventListener('keydown', this.handleStaticKeydown);
        this.staticPart.addEventListener('click', this.handleStaticClick);
        this.staticPart.addEventListener('keydown', this.handleStaticKeydown);

        window.removeEventListener('resize', this.handleResize);
        window.addEventListener('resize', this.handleResize);

        this.setOpen(this.dataset.openByDefault === 'true', false);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      isInteractiveElement(element) {
        const interactive = element.closest('a, button, input, select, textarea, label, summary, [role="button"], [role="link"], [tabindex]:not([tabindex="-1"])');
        return Boolean(interactive && interactive !== this.staticPart);
      }

      onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(!this.classList.contains('is-open'), true);
      }

      onStaticClick(event) {
        if (this.staticPart.dataset.clickArea !== 'static_and_button') return;
        if (this.isInteractiveElement(event.target)) return;
        if (event.target.closest('[data-expandable-toggle]')) return;
        this.setOpen(!this.classList.contains('is-open'), true);
      }

      onStaticKeydown(event) {
        if (this.staticPart.dataset.clickArea !== 'static_and_button') return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (this.isInteractiveElement(event.target)) return;
        event.preventDefault();
        this.setOpen(!this.classList.contains('is-open'), true);
      }

      setOpen(open, focusButton) {
        this.classList.toggle('is-open', open);
        this.staticPart.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (focusButton) this.toggleButton.focus({ preventScroll: true });
        }
        this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        this.updatePanelHeight();
      }

      updatePanelHeight() {
        if (!this.panel) return;
        if (!this.classList.contains('is-open')) {
          this.panel.style.maxHeight = '0px';
          return;
        }
        const target = this.panelInner || this.panel;
        this.panel.style.maxHeight = `${target.scrollHeight}px`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-countdown-exa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-countdown-exa')) {
    customElements.define(
      'shipping-countdown-exa',
      class ShippingCountdownExa extends HTMLElement {
        connectedCallback() {
          this.timeElement = this.querySelector('[data-shipping-countdown-value]');
          this.statusElement = this.querySelector('[data-shipping-status-value]');
          this.targetTime = null;
          this.update();
          this.interval = window.setInterval(() => this.update(), 1000);
        }

        disconnectedCallback() {
          window.clearInterval(this.interval);
        }

        update() {
          if (!this.timeElement) return;
          const now = new Date();
          const target = this.getTargetTime(now);
          let remaining = target.getTime() - now.getTime();

          if (remaining <= 0) {
            this.targetTime = null;
            remaining = this.getTargetTime(now).getTime() - now.getTime();
          }

          const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const value = `${this.format(hours)}:${this.format(minutes)}:${this.format(seconds)}`;

          this.timeElement.textContent = value;
          this.timeElement.setAttribute('datetime', `PT${hours}H${minutes}M${seconds}S`);

          if (this.statusElement) {
            this.statusElement.textContent = this.isAfterDailyCutoff(now) ? this.dataset.afterCutoffText || this.dataset.todayText || '' : this.dataset.todayText || '';
          }
        }

        getTargetTime(now) {
          if (this.dataset.mode === 'daily_cutoff') {
            const target = new Date(now);
            target.setHours(this.toNumber(this.dataset.cutoffHour, 23), this.toNumber(this.dataset.cutoffMinute, 59), 0, 0);
            if (target.getTime() <= now.getTime()) target.setDate(target.getDate() + 1);
            return target;
          }

          if (!this.targetTime || this.targetTime.getTime() <= now.getTime()) {
            const minutes = Math.max(1, this.toNumber(this.dataset.durationMinutes, 10));
            this.targetTime = new Date(now.getTime() + minutes * 60000);
          }

          return this.targetTime;
        }

        isAfterDailyCutoff(now) {
          if (this.dataset.mode !== 'daily_cutoff') return false;
          const cutoff = new Date(now);
          cutoff.setHours(this.toNumber(this.dataset.cutoffHour, 23), this.toNumber(this.dataset.cutoffMinute, 59), 0, 0);
          return now.getTime() > cutoff.getTime();
        }

        toNumber(value, fallback) {
          const parsed = Number.parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : fallback;
        }

        format(value) {
          return String(value).padStart(2, '0');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vp-slider-exa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-slider-scrub-exa')) {
    customElements.define('vp-slider-scrub-exa', class extends HTMLElement {
      constructor() {
        super();
        this.activePointerId = null;
        this.startX = 0;
        this.startY = 0;
        this.scrubbing = false;
        this.suppressClick = false;
        this.clearSuppressClickTimer = null;
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerEnd = this.onPointerEnd.bind(this);
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointermove', this.onPointerMove);
        this.addEventListener('pointerup', this.onPointerEnd);
        this.addEventListener('pointercancel', this.onPointerEnd);
        this.addEventListener('lostpointercapture', this.onPointerEnd);
        this.addEventListener('click', this.onClick, true);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointermove', this.onPointerMove);
        this.removeEventListener('pointerup', this.onPointerEnd);
        this.removeEventListener('pointercancel', this.onPointerEnd);
        this.removeEventListener('lostpointercapture', this.onPointerEnd);
        this.removeEventListener('click', this.onClick, true);
        window.clearTimeout(this.clearSuppressClickTimer);
      }

      onPointerDown(event) {
        if (!event.isPrimary || this.activePointerId !== null) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.activePointerId = event.pointerId;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.scrubbing = false;
      }

      onPointerMove(event) {
        if (event.pointerId !== this.activePointerId) return;
        const deltaX = Math.abs(event.clientX - this.startX);
        const deltaY = Math.abs(event.clientY - this.startY);

        if (!this.scrubbing) {
          if (deltaY > 10 && deltaY > deltaX) {
            this.resetPointer();
            return;
          }
          if (deltaX < 6 || deltaX < deltaY) return;
          this.scrubbing = true;
          this.suppressClick = true;
          if (this.setPointerCapture) this.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        this.selectAtPoint(event.clientX, event.clientY);
      }

      onPointerEnd(event) {
        if (event.pointerId !== this.activePointerId) return;
        if (this.scrubbing) this.selectAtPoint(event.clientX, event.clientY);
        this.resetPointer();
        if (this.suppressClick) {
          window.clearTimeout(this.clearSuppressClickTimer);
          this.clearSuppressClickTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 450);
        }
      }

      onClick(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
        window.clearTimeout(this.clearSuppressClickTimer);
      }

      resetPointer() {
        if (this.activePointerId !== null && this.hasPointerCapture && this.hasPointerCapture(this.activePointerId)) {
          this.releasePointerCapture(this.activePointerId);
        }
        this.activePointerId = null;
        this.scrubbing = false;
      }

      selectAtPoint(clientX, clientY) {
        const swatch = this.swatchAtPoint(clientX, clientY);
        if (!swatch) return;
        const input = swatch.querySelector('input[type="radio"]');
        if (!input || input.disabled || input.hidden || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      swatchAtPoint(clientX, clientY) {
        const directTarget = document.elementFromPoint(clientX, clientY);
        const directSwatch = directTarget && directTarget.closest ? directTarget.closest('.color-swatch') : null;
        if (directSwatch && this.contains(directSwatch)) return directSwatch;

        const bounds = this.getBoundingClientRect();
        if (clientX < bounds.left || clientX > bounds.right || clientY < bounds.top || clientY > bounds.bottom) return null;

        let nearest = null;
        let nearestDistance = Infinity;
        this.querySelectorAll('.color-swatch').forEach((swatch) => {
          if (swatch.classList.contains('non-existent')) return;
          const rect = swatch.getBoundingClientRect();
          if (rect.width <= 0 || rect.height <= 0) return;
          const insideY = clientY >= rect.top && clientY <= rect.bottom;
          const centerX = rect.left + rect.width / 2;
          const distance = Math.abs(clientX - centerX) + (insideY ? 0 : Math.min(Math.abs(clientY - rect.top), Math.abs(clientY - rect.bottom)) * 2);
          if (distance < nearestDistance) {
            nearest = swatch;
            nearestDistance = distance;
          }
        });
        return nearest;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
